<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage zipcode</p>
    </header>
    <section class="modal-card-body">
        <b-field label="Locality">
            <b-input
                type="text"
                v-model="zipcode.locality"
                placeholder="e.g. Akshar Chowk"
                required>
            </b-input>
        </b-field>
        <b-field label="Zipcode">
            <b-input
                type="number"
                v-model.number="zipcode.zipcode"
                placeholder="e.g. 390008"
                required>
            </b-input>
        </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manage">Save</button>
    </footer>
  </div>
</template>

<script>
import ZipcodeService from './service';

export default {
  name: 'manageZipcode',

  props: ['city'],

  data() {
    return {
      isLoading: false,
      zipcode: {}
    };
  },

  methods: {
    manage() {
      this.isLoading = true;

      ZipcodeService.manage(this.city, this.zipcode).then(newzipcode => {
        this.isLoading = false;
        const isNewzipcode = !this.zipcode.docId;
        const zipcodeObj = { ...this.zipcode };

        if (isNewzipcode) {
          zipcodeObj.id = this.zipcode.docId;
        }

        this.$bus.$emit('ZIPCODE_UPDATE', zipcodeObj, isNewzipcode);
        this.$emit('close');
        this.$toast.open('Operation successfull');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/cities/Zipcodes/ManageZipcode.vue